import React, { Component } from 'react';
import Form from '@platform/form';
import { Modal, Button } from '@platform/base';
import { toast } from '@platform/api';

export default function useSimpleTable(Table) {
    return class SimpleTableWithModal extends Component {
        render() {
            let { simpleTableConfig = {} } = this.props;
            let { open } = simpleTableConfig;
           
            return <>
                <Table {...this.props} />
                {open && <SimpleTableModal {...this.props}/>}
            </>;
        }
    };
}

useSimpleTable.displayName = 'useSimpleTable';
useSimpleTable.dependence = [];
useSimpleTable.hooks = function() {
    this.componentName = 'SimpleTable';
    this._formatOutputRow = row => {
        if (!row) {return;}
        return row.values;
    };
    this._formatInputRow = row => {
        ['status', 'rowId', 'isOptimized'].forEach(key => {
            if (Object.prototype.toString.call(row[key]).slice(8, -1) !== 'Object') {
                row.values[key] = { value: row[key] };
            }
        });

        return row;
    };
    return {
        openSimpleTableModal: (status, record, viewIndex) => {
            this.store.simpleTableModalInfo = {
                open: true,
                status,
                record,
                index: viewIndex,
                meta: this.store.leafColumnKeys
                    .filter(key => {
                        let { itemtype } = this.getColumnProps(key);
                        return itemtype !== 'label' && itemtype !== 'customer';
                    })
                    .map(key => this.getColumnProps(key)),
            };
            this.forceUpdate();
        },
        closeSimpleTableModal: () => {
            this.store.simpleTableModalInfo = {
                ...this.store.simpleTableModalInfo,
                open: false,
            };
            this.forceUpdate();
        },
        getSimpleTableModalInfo: () => {
            return this.store.simpleTableModalInfo;
        },
        setSimpleTableModalValue: (key, value) => {
            this.store.simpleTableModalInfo = this.store.simpleTableModalInfo || {};
            this.store.simpleTableModalInfo.record = this.store.simpleTableModalInfo.record || {};
            this.store.simpleTableModalInfo.record[key] = value; // simpleTable 的row 没有values
            this.forceUpdate();
        },
    };
};
useSimpleTable.propsGenerator = function(props) {
    if (!props?.simpleTableConfig?.enable) {
        return props;
    }
    
    return {
        ...props,
        simpleTableConfig: {
            ...props.simpleTableConfig,
            ...props.store.getSimpleTableModalInfo(),
            onClose: () => {
                props.store.closeSimpleTableModal();
                props.simpleTableConfig?.onClose?.();
            },
        },
    };

};

class SimpleTableModal extends Component {
    formStore = Form.useForm();

    componentDidMount() {
        let { simpleTableConfig = {} } = this.props;
        let { meta, record, status } = simpleTableConfig;

        this.formStore.setMeta({
            SimpleTableModal: {
                status: status === 'edit' || status === 'add' ? 'edit' : 'browse',
                items: meta.filter(column => {
                    // 默认设置下renderStatus
                    if (column.render && column.itemtype !== 'customer') {
                        column.renderStatus = column.renderStatus || 'edit';
                    }
                    return column.itemtype !== 'customer';
                }),
                moduletype: "form",
                name: /*locale['side_form']*/"侧拉表单",
                isunfold: false,
            },
        });
        this.formStore.setAllFormValue(record.values || {});
    }

    render() {
        let { simpleTableConfig = {}, locale = {}, type } = this.props;
        let { open, onClose, onAfterEvent, onBeforeEvent } = simpleTableConfig;
        let title = locale['table0015'];
        switch (type) {
            case 'add':
                title = locale['table0016'];
                break;
            case 'edit':
                title = locale['table0017'];
                break;
            default:
                break;
        }
        return <Modal
            id="tableModal"
            visible={open}
            className="table-modal"
            mask="static"
            // animation={false}//已废弃
            onCancel={onClose}
        >
            <Modal.Header closeButton clsPrefix='wui-modal-header' >
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body clsPrefix='wui-modal-body'>
                <Form
                    name="SimpleTableModal"
                    config={{
                        onAfterEvent,
                        onBeforeEvent,
                    }}
                    store={this.formStore}
                ></Form>
            </Modal.Body>
            <Modal.Footer clsPrefix='wui-modal-footer'>
                <Button className="btn-2" onClick={this.handleSubmit}>
                    {locale['table0021']}
                </Button>
                <Button className="btn-2 btn-cancel" onClick={onClose} shape="border">
                    {locale['table_cancel']}
                </Button>
            </Modal.Footer>
        </Modal>;
    }

    handleSubmit = () => {
        let { simpleTableConfig = {} } = this.props;
        let { tableModelConfirm, status } = simpleTableConfig;
        let { requiredItems, regItems, maxItems } = this.formStore.isCheckNow(true);
        if (requiredItems.length || regItems.length || maxItems.length) {

            let json = this.formStore.getInnerHooks().getJson();

            let toastContent = '';

            if (requiredItems.length) {
                toastContent += `${json['page-form-0001']}：${requiredItems.join(', ')}\n`;
            }
            if (regItems.length) {
                toastContent += `${json['page-form-0002']}：${regItems.join(', ')}\n`;
            }
            if (maxItems.length) {
                toastContent += `${json['page-form-0010']}：${maxItems.join(', ')}`;
            }

            toast({
                mark: 'form_isCheckNow',
                color: 'danger',
                title: json['page-form-0009'],
                content: toastContent,
            });
        } else {
            let formData = this.formStore.getAllFormValue();
            tableModelConfirm?.(formData, status);
        }
    }
}